import { render, staticRenderFns } from "./Create-Public-Folder.vue?vue&type=template&id=886d90e0&scoped=true&"
import script from "./Create-Public-Folder.vue?vue&type=script&lang=js&"
export * from "./Create-Public-Folder.vue?vue&type=script&lang=js&"
import style0 from "./Create-Public-Folder.vue?vue&type=style&index=0&id=886d90e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886d90e0",
  null
  
)

export default component.exports